import { render } from "./Investor.vue?vue&type=template&id=ce27d154"
import script from "./Investor.vue?vue&type=script&lang=js"
export * from "./Investor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__